import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
  Typography
} from '@mui/material';
import { deleteView, saveView } from '../../ducks/actions';
import { getCurrentView, getDeleteLoading, getDeleteViewApiUrl, getViewsInfo } from '../../ducks/selectors';

interface DeleteViewManagementProps {
  open: boolean;
  onClose: () => void;
  selectedClient?: any;
}

const DeleteViewManagement: React.FC<DeleteViewManagementProps> = ({
  open,
  onClose,
  selectedClient
}) => {
  const dispatch = useDispatch();
  const deleteLoading = useSelector(getDeleteLoading);
  const viewInfo = useSelector(getViewsInfo);
  const currentView = useSelector(getCurrentView);
  const apiUrl = useSelector(getDeleteViewApiUrl(viewInfo?.portfolioViewId));

  const handleDelete = async () => {
    if (currentView.trim()) {
      // Get current view configuration (this should be passed from the parent component or context)
      const viewData = {
        viewName: currentView.trim(),
      };

      await dispatch(deleteView({ apiUrl, viewData }));
    }
  };

  const isValid = currentView.trim().length > 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '8px',
          width: { xs: 'calc(100vw - 32px)', sm: '100%' },
          maxWidth: '500px'
        }
      }}
    >
      <DialogTitle
        sx={{
          p: 2,
          fontSize: '18px',
          fontWeight: 600,
          color: '#1A1A1A',
          lineHeight: '24px'
        }}
      >
        Delete view
      </DialogTitle>

      <Box sx={{ px: 2, pb: 2 }}>
        <Typography
          variant="body2"
          sx={{ mb: 2, fontSize: '16px', lineHeight: '24px', color: '#1A1A1A' }}
        >
          {(currentView || 'This view')} is currently in use. If you delete it, your workspace will revert to the Portfolio Default view.
          <br />
          Are you sure you want to delete this view?
        </Typography>

      </Box>

      <DialogActions
        sx={{
          px: 2,
          pb: 3,
          gap: 1,
          justifyContent: 'flex-end'
        }}
      >
        <Button
          onClick={onClose}
          disabled={deleteLoading}
          variant="outlined"

        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color='secondary'
          variant="contained"
          disabled={!isValid || deleteLoading}

        >
          {deleteLoading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} color="inherit" />
              Deleting...
            </Box>
          ) : (
            'Delete'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteViewManagement;